import { DefensivePlayerPositions } from 'enums/DefensivePlayerPositions';
import { IApiPlayerExtended } from '@trackman/baseball-shared-components';
import { ISequence } from 'interfaces/tagging/ISequence';
import { Play } from 'models/tagging/Play';

export const getPlayersBySequenceNumber = (sequence: ISequence[], selectedPlay: Play): IApiPlayerExtended[] => {
  const playersSequence: IApiPlayerExtended[] = [];

  sequence.forEach((playerNumber: number | string) => {
    const player = selectedPlay
      .getPitchingTeamLineup()
      .players.find((player) => player.position === DefensivePlayerPositions[playerNumber as number]);
    if (player) {
      playersSequence.push(player);
    }
  });

  return playersSequence;
};

export const getSequenceNumberByPlayers = (savedSequence: IApiPlayerExtended[]): ISequence[] => {
  const tempArr: ISequence[] = [];

  savedSequence.forEach((player: IApiPlayerExtended) => tempArr.push(DefensivePlayerPositions[player?.position]));

  return tempArr;
};
